import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line', 
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },
    {
        id: 4,
        label: 'MENUITEMS.SALESREPUSERS.TEXT',
        icon: 'ri-group-line',
        link: '/salesreps'
    },
    {
        id: 5,
        label: 'MENUITEMS.LOCATION.TEXT',
        icon: 'ri-map-pin-line', 
        link: '/locations'
    },
    // {
    //     id: 6,
    //     label: 'MENUITEMS.CABINETS.TEXT',
    //     icon: 'ri-archive-line', 
    //     link: '/cabinets'
    // },
    {
        id: 7,
        label: 'MENUITEMS.BOARDS.TEXT',
        icon: 'ri-layout-grid-line', 
        link: '/boards'
    },
    {
        id: 8,
        label: 'MENUITEMS.ACTIVATION.TEXT',
        icon: 'ri-toggle-line', 
        link: '/activations'
    },
    {
        id: 9,
        label: 'Pending Collections',
        icon: 'ri-time-line',
        link: '/pending-collections'
    },
    {
        id: 10,
        label: 'Konnect Live Reads',
        icon: 'ri-flashlight-line',
        link: '/fusion-connect'
    },
    {
        id: 11,
        label: 'Konnect Live Stats',
        icon: 'ri-line-chart-line',
        link: '/fusion-connect-stats'
    },

];